/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
export type VehicleIconLinkVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  inService: boolean | null
  label: number | null
}

export const VehicleIconLinkVehicleFragmentDoc = gql`
    fragment VehicleIconLinkVehicle on Vehicle {
  id
  inService
  label
}
    `
